import { render } from "./ThumbGallery.vue?vue&type=template&id=57689896&scoped=true"
import script from "./ThumbGallery.vue?vue&type=script&lang=js"
export * from "./ThumbGallery.vue?vue&type=script&lang=js"

import "./ThumbGallery.vue?vue&type=style&index=0&id=57689896&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57689896"

export default script